var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6084 10.7944V14.6109C1.6084 15.931 2.67812 17.0007 3.99816 17.0007H17.0024C18.3217 17.0007 19.3921 15.931 19.3921 14.6109V10.7944H1.6084ZM8.31192 14.0015H4.39486C4.05493 14.0015 3.7793 13.7259 3.7793 13.386C3.7793 13.046 4.05493 12.7704 4.39486 12.7704H8.31192C8.65185 12.7704 8.92749 13.046 8.92749 13.386C8.92749 13.7259 8.65185 14.0015 8.31192 14.0015Z",
    fill: "#E9A5F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6084 7.17651H19.3914V9.76873H1.6084V7.17651Z",
    fill: "#F6DBFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3683 6.15038C19.2465 4.94455 18.2404 4 17.0031 4H3.99893C2.76096 4 1.75485 4.94455 1.63379 6.15038H19.3683Z",
    fill: "#E9A5F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/creditCard.8f90e7ea1b595e5eb281ff478ca6c89b.svg";
export { ForwardRef as ReactComponent };